var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsNotificationsOutlineBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Notifications") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Outline-v2",
    d: "M88,61.21l-8.09-3.68-7-22.69a9,9,0,0,0-8.58-6.34H39.71a9,9,0,0,0-8.58,6.34l-7,22.69L16,61.21V73.5H88ZM83.5,69h-63V64.1L26,61.62l1.84-.83.6-1.93,7-22.69A4.49,4.49,0,0,1,39.72,33H64.28a4.49,4.49,0,0,1,4.3,3.17l7,22.69.6,1.93,1.84.83L83.5,64.1ZM62,80.25H42a15.32,15.32,0,0,0,20.08,0ZM39.33,24h4.9a9,9,0,0,1,15.54,0h4.9a13.42,13.42,0,0,0-25.34,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsNotificationsOutlineBrand);
export default __webpack_public_path__ + "static/media/Icons_Notifications_Outline_Brand.58fb39853cda8a815125bc4db6f91dde.svg";
export { ForwardRef as ReactComponent };